import { useQuery } from "react-query";

import { getClinicianBasicInfoAsync } from "api/clinician";
import { GET_CLINICIAN_BASIC_INFO, STALE_TIME_5_MINUTES } from "constants/reactQueryKeys";

export const useGetClinicianBasicInfo = (clinicianId, options = {}) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_CLINICIAN_BASIC_INFO, clinicianId],
    () => getClinicianBasicInfoAsync(clinicianId),
    {
      enabled: Boolean(clinicianId),
      refetchOnWindowFocus: false,
      staleTime: STALE_TIME_5_MINUTES,
      ...options,
    }
  );

  return {
    clinicianBasicInfo: data?.data || null,
    clinicianBasicInfoLoading: isLoading,
    ...rest,
  };
};
